import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { WeatherHistory } from 'types/Meteorology/Weather/Area/getHistoryResponse';
import { transformGetHistoryResponse } from 'helper/Meteorology/Weather/Area/History';
import GetHistoryParams from 'types/Meteorology/Weather/Area/getHistoryParams';

export const weatherAreaHistoryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getHistory: build.query<WeatherHistory, GetHistoryParams>({
      transformResponse: transformGetHistoryResponse,
      query: ({ area }) => {
        const productKey = getProductKey('meteorologia');
        return {
          url: `produtos/clima_exclusivo/history/?product_key=${productKey}`,
          method: 'POST',
          body: { area },
        };
      },
    }),
  }),
});

export const {
  useGetHistoryQuery,
} = weatherAreaHistoryApi;
